import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";

const cols = [
  { title: "Company", links: [["About Us", "/about"], ["Solutions", "/solutions"], ["Events", "/events"], ["Resources", "/resources"], ["Contact Us", "/contact"]] },
  { title: "Services", links: [["Custom Software", "/services/custom-software"], ["App Development", "/services/app-development"], ["AI Agents", "/services/ai-agents"], ["Creative Design", "/services/creative-design"]] },
  { title: "Products", links: [["Zoho Workplace", "/products/zoho"], ["Absolute Secure Access", "/products/absolute"], ["Adobe", "/products"], ["Razorpay", "/products"]] },
  { title: "Quick Links", links: [["Terms & Conditions", "/legal/terms-and-conditions"], ["Cancellations & Refunds", "/legal/cancellations-refunds"], ["Cookies Policy", "/legal/cookies-policy"], ["Privacy Policy", "/legal/privacy-policy"]] },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-ink text-slate-200">
      <div className="max-w-8xl mx-auto px-6 py-20 grid grid-cols-2 md:grid-cols-6 gap-10">
        <div className="col-span-2">
          <img src="/thinksmiths-logo-white.png" alt="The ThinkSmiths" className="h-20 w-auto object-contain mb-5" />
          <p className="text-sm max-w-xs leading-relaxed">Empathy-focused, value-driven software & IT services for the modern enterprise. Technology that respects your audience enough to have a real conversation.</p>
          <div className="mt-6 space-y-2.5 text-sm">
            <a href="mailto:info@thethinksmiths.com" className="flex items-center gap-2 hover:text-white transition-colors"><Mail size={15} /> info@thethinksmiths.com</a>
            <a href="tel:+919986537837" className="flex items-center gap-2 hover:text-white transition-colors"><Phone size={15} /> +91 99865 37837</a>
            <a href="tel:+919600063013" className="flex items-center gap-2 hover:text-white transition-colors"><Phone size={15} /> +91 96000 63013</a>
            <p className="flex items-center gap-2"><MapPin size={15} /> Hyderabad · Bangalore, India</p>
          </div>
        </div>
        {cols.map((c) => (
          <div key={c.title}>
            <div className="label text-[10px] text-slate-300 mb-4">{c.title}</div>
            <ul className="space-y-2.5 text-sm">
              {c.links.map(([label, to]) => (
                <li key={label}><Link to={to} className="hover:text-white transition-colors">{label}</Link></li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-8xl mx-auto px-6 py-5">
          <div className="label text-[10px] text-slate-400 mb-3">Software Development and MarTech Company in</div>
          <div className="flex flex-wrap gap-x-6 gap-y-2 text-sm">
            {[["Bengaluru", "bengaluru"], ["Hyderabad", "hyderabad"], ["Chennai", "chennai"]].map(([label, slug]) => (
              <Link key={slug} to={`/software-development-company/${slug}`} className="text-slate-300 hover:text-white transition-colors">{label}</Link>
            ))}
          </div>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-8xl mx-auto px-6 py-6 text-xs">
          <p>© {new Date().getFullYear()} ThinkSmiths Software Services Pvt. Ltd. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
